module.exports = __webpack_public_path__ + "img/frightened_active.aa895f00.svg";